import { getEnv, getEnvBoolean } from './env';

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/g, '');

const getIsRemoteDeployment = (): boolean => {
  return getEnvBoolean('VITE_IS_REMOTE_DEPLOYMENT', false);
};

const getLocalUrl = (): string => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  const host = getEnv('VITE_HOST') ?? '';
  const port = getEnv('VITE_PORT') ?? '';

  if (!host || !port) {
    return '';
  }

  return `https://${host}:${port}`;
};

export const getMainApiUrl = (): string => {
  if (!getIsRemoteDeployment()) {
    const prefix = getEnv('VITE_MAIN_API_LOCAL_PREFIX') ?? '';
    return trimTrailingSlashes(`${getLocalUrl()}/${prefix}`);
  }

  const host = getEnv('VITE_SERVER_MAIN_API_HOST') ?? '';
  return trimTrailingSlashes(`${host}/api`);
};

export const getPublicUrl = (): string => {
  if (!getIsRemoteDeployment()) {
    const prefix = getEnv('VITE_PUBLIC_API_LOCAL_PREFIX') ?? '';
    return trimTrailingSlashes(`${getLocalUrl()}/${prefix}`);
  }

  return trimTrailingSlashes(
    String(getEnv('VITE_SERVER_PUBLIC_API_HOST') ?? ''),
  );
};

export const getGigyaUrl = (): string => {
  if (!getIsRemoteDeployment()) {
    const prefix = getEnv('VITE_GIGYA_API_LOCAL_PREFIX') ?? '';
    return trimTrailingSlashes(`${getLocalUrl()}/${prefix}`);
  }

  return trimTrailingSlashes(String(getEnv('VITE_GIGYA_API_HOST') ?? ''));
};
